module.exports = __webpack_public_path__ + "static/media/logo.1f5cc0c2.png";